import React from 'react';
import Icon from 'components/Icon/Icon';
import Loader from 'components/Loader/Loader';

const PostSearchCreatives = ({
  searching,
  freelancer,
  specificFreelancerSelected,
  isPrivate,
}) => {
  let loadingText = 'Checking our freelancers availability and rates...';
  let loadedTextStart = 'We have available freelancers';
  let loadedTextEnd = ' so Twine contacts our freelancers about your project.';
  if (specificFreelancerSelected && isPrivate) {
    loadingText =
      'Checking ' + freelancer.displayname + "'s availability and rates...";
    loadedTextStart = 'Checked availablity';
    loadedTextEnd = ` so Twine contacts ${freelancer.displayname} about your project.`;
  }
  return (
    <div className="text-center" id="post-brief-searching-creatives">
      {searching && (
        <div>
          <Loader loading />
          <p className="fs-15 mt">{loadingText}</p>
        </div>
      )}
      {!searching && (
        <div>
          <Icon color="#0fe2af" icon="&#xe633;" size="5em" />
          <h4>
            <strong id="post-brief-found-creatives">{loadedTextStart}</strong>
          </h4>
          <p className="fs-15">
            <strong>Continue</strong>
            {loadedTextEnd}
          </p>
        </div>
      )}
    </div>
  );
};

export default PostSearchCreatives;
